<template>
  <div></div>
</template>

<script>
export default {
  name: 'KiccPayment',
  props: [
    'locale'
  ],
  computed: {
    getPayInfo: {
      get () {
        return this.$store.getters['payment/getPaymentInfo']
      },
      set (data) {
        this.payInfo = this._.cloneDeep(data)
      }
    }
  },
  mounted () {
    this.isSeparate = this.$route.name === 'separatePayment'
    if (this.getPayInfo) {
      this.payInfo = this._.cloneDeep(this.getPayInfo)
      // 알림톡 등으로부터 접근한 기본루트
      if (!this.isSeparate) {
        setTimeout(() => {
          window.location.href = this.payInfo.url
        }, 100)
      } else {
        // QR코드로부터 접근한 독립 결제루트
      }
    }
  },
  data () {
    return {
      payInfo: null,
      isSeparate: false
    }
  }
}
</script>
